<template>
  <div v-if="selectedMenu == 1" class="uv-card">
    <div class="uv-card-body">
      <h3 class="uv-card-title">Clientes</h3>
      <uv-data-table :config="config" :data="data_clientes" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
    </div>
    <v-dialog
      v-model="showModal"
      :showFooter="false"
      title="Clientes"
      max-width="1000"
      persistent
    >
      <v-card style="background-color: rgb(234, 237, 255);">
        <v-toolbar dark :color="$pgsHelper.uiConfig().mainColor">
          <v-btn icon dark @click="toggleModal(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Cliente</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <div class="my-2 mx-6" >
          <ClienteForm :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"></ClienteForm>
        </div>
        <v-divider></v-divider>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>

    <modal v-model="showModalFinger" :showFooter="false" title="Vincular huella">
      <FingerPrintSync v-if="showModalFinger" @toggle="showModalFinger = false" :key="fingerSyncIndex"
        :cliente="clienteSync"></FingerPrintSync>
    </modal>
    <modal v-model="showModalFingerFinder" :showFooter="false" title="Buscar huella">
      <FingerReader v-if="showModalFingerFinder" :key="fingerFinderIndex" />
    </modal>

    <v-dialog v-model="showModalQrCliente" :showFooter="false" title="Generar QR " max-width="350" persistent>
      <v-card>
        <v-toolbar dark :color="$pgsHelper.uiConfig().mainColor">
          <v-btn icon dark @click="showModalQrCliente = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Generar QR</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <div class="my-2 mx-6 text-center font-weight-bold">
          <QrCreator :config="qrConfig.config" :descargar="qrConfig.descargar" :key="QrClienteIndex" />
        </div>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import modal from "../../MainComponents/modal.vue";
import Cliente from "../../../clases/Cliente.js";
import ClienteForm from "../../Clientes/Clientes/ClienteForm.vue";
import FingerPrintSync from "./FingerPrintSync";
import FingerReader from "./FingerReader";
import QrCreator from "../../MainComponents/QrCreator.vue";
import moment from "moment";
export default {
  name: "ClientesCRUD",
  components: {
    uvDataTable,
    modal,
    ClienteForm,
    FingerPrintSync,
    FingerReader,
    QrCreator,
  },
  data() {
    return {
      showModalFingerFinder: false,
      clienteSync: null,
      editMode: false,
      editData: {},
      formIndex: 1,
      indexComponent: 1,
      access: [],
      showModal: false,
      showModalFinger: false,
      clientAdd: {
        nombre: "",
        apellidos: "",
        correo: "",
        telefono: "",
        grupo: "",
        tipoMembresia: "",
      },
      config: {
        orderByCol: { Field: "Apellidos", Type: "Asc" },
        selectableRow: true,
        rawText: "Clientes",
        allowExport: true,
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addClient",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarClient",
            require: true,
          },
          {
            text: "Enrolamiento de huella",
            icon: "mdi mdi-fingerprint",
            type: "mdi",
            buttonId: "syncFingerClient",
            require: true,
          },
          {
            text: "Verificador de huella",
            icon: "mdi mdi-fingerprint",
            type: "mdi",
            buttonId: "findFingerClient",
            require: false,
          },
          {
            text: "Generar QR",
            icon: "mdi mdi-qrcode-plus",
            type: "mdi",
            buttonId: "QRClient",
            require: false,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteClient",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "NCompleto",
          },
          {
            text: "Identificador de cliente",
            value: "Id",
          },
          {
            canBeFiltered: true,
            dateFilterMode: "all",
            text: "Fecha Creación",
            value: "FechaCreacion",
            format: (row) => {
              return moment(row.FechaCreacion).format("DD-MM-YYYY");
            },
          },
          {
            canBeFiltered: true,
            dateFilterMode: "month",
            text: "Cumpleaños",
            value: "FechaNacimiento",
            format: (row) => {
              if (row.FechaNacimiento != "") {
                return moment(row.FechaNacimiento).format("DD-MM-YYYY");
              } else {
                return "Sin fecha";
              }

            },
          },
          {
            title: "Email",
            dataName: "Correo",
            text: "Alias",
            value: "Apodo",
          },
          {
            title: "Email",
            dataName: "Correo",
            text: "Email",
            value: "Correo",
          },
          {
            text: "Telefono",
            value: "Telefono",
            format: (row) => {
              return row.CountryCode + " " + row.Telefono;
            },
          },
          {
            text: "Grupo",
            value: "tipo",
          },
          {
            title: "Email",
            dataName: "Correo",
            text: "Huella",
            value: "Fingerprint",
            format: (row) => {
              return row.Fingerprint != "" ? "Capturado" : "";
            },
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
      claims: {},
      //data_clientes:[],
      selectedMenu: 1,
      fingerSyncIndex: 0,
      fingerFinderIndex: 0,
      qrConfig: {
        config: {},
        descargar: {},
      },

      QrClienteIndex: 0,
      showModalQrCliente: false,
      NombreCliente: "",
    };
  },
  computed: {
    data_clientes() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((element) => {
        if (element.Id != "PUBLICOGENERAL") {
          element.NombreAlias =
            element.Nombres + (element.Apodo ? " (" + element.Apodo + ")" : "");
          element.NCompleto =
            element.Nombres +
            " " +
            element.Apellidos +
            (element.Apodo ? " (" + element.Apodo + ")" : "");
          element.crat = moment(element.FechaCreacion).format("DD-MM-YYYY")
          clientes.push(element);
        }
      });
      return clientes;
    },
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addClient") {
        this.editMode = false;
        this.editData = {};
        this.formIndex++;
        this.toggleModal(true);
      }
      if (buttonId == "editarClient") {
        this.idSelected = idSelected[0];
        let cliente = this.$pgsHelper.getById(
          this.data_clientes,
          "Id",
          idSelected[0]
        );
        this.formIndex++;
        this.editMode = true;
        this.editData = cliente;
        this.toggleModal(true);
      }
      if (buttonId == "deleteClient") {
        this.deleteCliente(idSelected[0]);
      }
      if (buttonId == "syncFingerClient") {
        this.clienteSync = this.$pgsHelper.getById(
          this.data_clientes,
          "Id",
          idSelected[0]
        );
        this.fingerSyncIndex++;
        this.showModalFinger = true;
        //this.fingerSyncIndex++
      }
      if (buttonId == "findFingerClient") {
        this.fingerFinderIndex++;
        this.showModalFingerFinder = true;
        //this.fingerSyncIndex++
      }
      if (buttonId == "QRClient") {
        let cliente = this.$pgsHelper.getById(
          this.data_clientes,
          "Id",
          idSelected[0]
        );

        this.NombreCliente = cliente.Nombres + " " + cliente.Apellidos;
        this.QrClienteIndex++;
        this.showModalQrCliente = true;
        this.qrConfig.config = {
          styles: {
            width: 300,
            height: 300,
            colorDark: "#000000",
            colorLight: "#FFFFFF",
          },
          qr: {
            text: "CLI_" + idSelected[0],
            level: "H",
          },
          text: {
            content: this.NombreCliente,
            font: "20px roboto",
            color: "#000000",
            margin: -15,
          },
        };
        this.qrConfig.descargar = {
          nombreArchivo: this.NombreCliente,
          extension: "jpeg",
        };
      }
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    editarClient() {
      if (!this.validateClientForm()) {
        this.$swal({
          icon: "error",
          title: "Proporcione nombre, apellidos y correo del cliente",
          text: "Complete los campos faltantes",
        });
        return false;
      }

      this.$swal({
        title: "¿Deseas guardar la información del cliente?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = {
            Id: this.idSelected,
            Nombres: this.clientAdd.nombre,
            Apellidos: this.clientAdd.apellidos,
            Correo: this.clientAdd.correo,
            Telefonos: [this.clientAdd.telefono],
            Telefono: this.clientAdd.telefono,
            Grupo: this.clientAdd.grupo,
          };
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Clientes-updateCliente", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$pgsHelper.writeLog({
              Evento: "CLIENTE_EDIT",
              Mensaje: `Cliente editado: ${this.clientAdd.nombre || ""} ${this.clientAdd.apellidos || ""}`.trim(),
              reference: { id: this.idSelected, tp: "CLI-Cliente", al: `${this.clientAdd.nombre || ""} ${this.clientAdd.apellidos || ""}`.trim() || "CLIENTE" },
              data: {
                Id: this.idSelected,
                Nombres: this.clientAdd.nombre,
                Apellidos: this.clientAdd.apellidos,
                Correo: this.clientAdd.correo,
                Telefono: this.clientAdd.telefono,
                Grupo: this.clientAdd.grupo,
              }
            });
            this.$swal({
              title: "Guardado",
              text: "El cliente se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              //this.getClientes();
            });
          } else {
            this.$swal("Error saving client", result.value.data.error, "error");
          }
        }
      });
    },
    deleteCliente(id) {
      const deletedObject = this.$pgsHelper.getById(this.data_clientes, "Id", id) || { Id: id };
      let datos = { Id: id };
      this.$swal({
        title: "¿Deseas eliminar este cliente?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Clientes-deleteCliente", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            const clientName = deletedObject.NCompleto || deletedObject.Nombres || id;
            this.$pgsHelper.writeLog({
              Evento: "CLIENTE_DELETE",
              Mensaje: `Cliente eliminado: ${clientName}`,
              reference: { id: id, tp: "CLI-Cliente", al: clientName },
              data: deletedObject
            });
            this.$swal("El cliente se elimino correctamente", "", "success");
            //this.getClientes();
            this.$forceUpdate();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function () { },
  mounted: function () {
    //this.getClientes();
  },
};
</script>
